export default {
  methods: {
    isDirty: function () {
      return this.$v.$anyDirty;
    },
    hasErrors: function () {
      return this.$v.$anyError;
    },
    validate: function () {
      this.$v.$touch();
    },
    resetValidation: function () {
      return this.$v.$reset();
    },
  },
};
